module.exports = __webpack_public_path__ + "fa95f30743d808574de5792d9a611d51.png";